import { P11N_STORE } from "./store";
import {
  getCloudflareData,
  getIsPDUser,
  getSegmentData,
  getLanguage,
} from "./sources";
import globalRules from "./global-rules";
import { trackPersonalizationViewed } from "../segment/personalization.js";

const initializeP11nStore = () => {
  if (P11N_STORE.isInitialized()) {
    return;
  }

  // Save initial data to the store
  P11N_STORE.set("cfData", getCloudflareData());
  P11N_STORE.set("segmentData", getSegmentData());
  P11N_STORE.set("isPDUser", getIsPDUser());
  P11N_STORE.set("lang", getLanguage());
};

/**
 * Run personalization rules
 * @param {import('./global-rules').PersonalizationRules} rules
 */
export const runPersonalizationRules = (rules) => {
  initializeP11nStore();

  for (const rule of rules) {
    if (rule.conditions.every((condition) => condition(P11N_STORE))) {
      rule.actions.forEach((action) => action(P11N_STORE));
      trackPersonalizationViewed(rule);
    }
  }
};

/**
 * Run global personalization rules
 */
export const runGlobalPersonalizationRules = () => {
  runPersonalizationRules(globalRules);
};
